__turbopack_context__.v({
  "arrive": "website-editorial-page-hero-module__r9rF8a__arrive",
  "contactVideo": "website-editorial-page-hero-module__r9rF8a__contactVideo",
  "copy": "website-editorial-page-hero-module__r9rF8a__copy",
  "environment": "website-editorial-page-hero-module__r9rF8a__environment",
  "hero": "website-editorial-page-hero-module__r9rF8a__hero",
  "layout": "website-editorial-page-hero-module__r9rF8a__layout",
  "media": "website-editorial-page-hero-module__r9rF8a__media",
  "shade": "website-editorial-page-hero-module__r9rF8a__shade",
});
